<template>
  <div>
    <vs-row>
      <vs-col vs-w="3" class="mr-5 border-right"> 
        <div class="list-scrollable">
          <transition-group class="vx-timeline" name="list-enter-up" tag="ul" appear>
            <li 
              class="cursor-pointer todo_todo-item"
               :style="[{transitionDelay: (index * 0.1) + 's'}]"
                v-for="(item, index) in historyData" :key="item.time">
               <div @click="selectHistory(item.id)" class="px-4 py-4 list-item-component">
                <div class="timeline-icon bg-primary" >
                  <feather-icon icon="ClockIcon" svgClasses="text-white stroke-current w-5 h-5" />
                </div>
                <div class="timeline-info">
                  <p class="font-semibold">{{ item.title }}</p>
                  <span class="activity-desc">{{ item.time | toDate }}</span>
                </div>
              </div>
            </li>
          </transition-group>
        </div>
       
      </vs-col>
      <vs-col v-if="selectedKpuId" vs-w="4" class="mr-5 border-right">
        <h6>{{ $t('KPU.Tab2') }}</h6>
        <vs-row class="mt-3 mb-3">
          <vs-col vs-w="6" class="mr-5">
            <validated-input
            :disabled="true"
            :label="$t('KPU.GoldPrice')"
            v-model="kpuGoldPrice"
            ></validated-input>
          </vs-col>
          <vs-col vs-w="5">
            <validated-input
            :disabled="true"
            :label="$t('KPU.ExchangeRate')"
            v-model="kpuExchangeRate"
            ></validated-input>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="6" class="mr-5">
            <validated-input
            :disabled="true"
            :label="$t('KPU.AnnualProductionOz')"
            v-model="kpuAnnualProductionOz"
            ></validated-input>
          </vs-col>
          <vs-col vs-w="5">
            <validated-input
            :disabled="true"
            :label="$t('KPU.CostToFirstOunce')"
            v-model="kpuCostToFirstOunce"
            ></validated-input>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="6" class="mr-5">
            <validated-input
            :disabled="true"
            :label="$t('KPU.TotalProductionOz')"
            v-model="kpuTotalProductionOz"
            ></validated-input>
          </vs-col>
          <vs-col vs-w="5">
            <validated-input
            :disabled="true"
            :label="$t('KPU.CashCost')"
            v-model="kpuCashCost"
            ></validated-input>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="6" class="mr-5">
            <validated-input
            :disabled="true"
            :label="$t('KPU.ProductionStartUpDate')"
            v-model="kpuProductionStartUpDate"
            ></validated-input>
          </vs-col>
          <vs-col vs-w="5">
            <validated-input
            :disabled="true"
            :label="$t('KPU.AISC')"
            v-model="kpuAISC"
            ></validated-input>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="6" class="mr-5">
            <validated-input
            :disabled="true"
            :label="$t('KPU.MineLifeYears')"
            v-model="kpuMineLifeYears"
            ></validated-input>
          </vs-col>
          <vs-col vs-w="5">
            <validated-input
            :disabled="true"
            :label="$t('KPU.IRRAfterTax')"
            v-model="kpuIRRAfterTax"
            ></validated-input>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="6" class="mr-5">
            <validated-input
            :disabled="true"
            :label="$t('KPU.InitialCapex')"
            v-model="kpuInitialCapex"
            ></validated-input>
          </vs-col>
          <vs-col vs-w="5">
            <validated-input
            :disabled="true"
            :label="$t('KPU.NPVAfterTax')"
            v-model="kpuNPVAfterTax"
            ></validated-input>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="6" class="mr-5">
            <validated-input
            :disabled="true"
            :label="$t('KPU.IRRStandard', {goldPrice : kpuStandardGoldPrice, fxRate : kpuStandardFXRate})"
            v-model="kpuIRRStandard"
            ></validated-input>
          </vs-col>
          <vs-col vs-w="5">
            <validated-input
            :disabled="true"
            :label="$t('KPU.NPVStandard', {goldPrice : kpuStandardGoldPrice, fxRate : kpuStandardFXRate})"
            v-model="kpuNPVStandard"
            ></validated-input>
          </vs-col>
        </vs-row>
      </vs-col>
      <vs-col v-if="selectedKpuId" vs-w="4">
        <h6 class="mb-3">{{ $t('KPU.YearlyCashFlows') }}</h6>
        <vs-row
          class="mb-3"
          :data="row"
          :key="indexRow"
          v-for="(row, indexRow) in kpuYearlyCashFlows"
        >
          <vs-col vs-w="2" class="mr-5">
            <h6 class="mt-10">{{ row.year }}</h6>
          </vs-col>
          <vs-col vs-w="4" class="mr-5">
            <validated-input
            :disabled="true"
            :label="$t('KPU.CashFlow')"
            v-model="row.value"
            ></validated-input>
          </vs-col>
          <vs-col vs-w="4">
            <validated-input
            :disabled="true"
            :label="$t('KPU.CumulativeCashFlow')"
            v-model="row.cumulativeValue"
            ></validated-input>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>
  </div>
</template>
<script>
import {
  ValidatedInput
} from "../../../shared/components";

export default {
  props: {
    histories: {
      type: Array,
      default: () => []
    }
  },
  components: {
    ValidatedInput
  },
  data() {
    return {
      selectedKpuId: null,
      kpuGoldPrice: 0,
      kpuAnnualProductionOz: 0,
      kpuTotalProductionOz: 0,
      kpuProductionStartUpDate: 0,
      kpuMineLifeYears: 0,
      kpuInitialCapex: 0,
      kpuExchangeRate: 0,
      kpuCostToFirstOunce: 0,
      kpuCashCost: 0,
      kpuAISC: 0,
      kpuIRRStandard: 0,
      kpuIRRAfterTax: 0,
      kpuNPVAfterTax: 0,
      kpuNPVStandard: 0,
      kpuStandardFXRate: 1.3,
      kpuStandardGoldPrice : 1500,
      kpuYearlyCashFlows : []
    };
  },
  computed: {
    historyData() {
      return this.histories.map(obj => {
        return {
          id: obj.kpuId,
          title : this.getProjectLeader(obj.createdBy),
          time : obj.submissionTime
        }
      })
    }
  },
  methods: {
    getProjectLeader(name) {
      const leader = this.$store.state.kpu.projectLeaders.find(l => l.userPrincipalName === name);
      if (leader === undefined)
        return  name;
      
      return leader.displayName;
    },
    selectHistory(id) {
      this.selectedKpuId = id;
      const history = this.histories.find(h => h.kpuId === id);
      this.kpuGoldPrice = history.goldPrice;
      this.kpuAnnualProductionOz = history.annualProductionOz;
      this.kpuTotalProductionOz = history.totalProductionOz;
      this.kpuProductionStartUpDate = history.productionStartUpDate;
      this.kpuMineLifeYears = history.mineLifeYears;
      this.kpuInitialCapex = history.initialCapex;
      this.kpuExchangeRate = history.exchangeRate;
      this.kpuCostToFirstOunce = history.costToFirstOunce;
      this.kpuCashCost = history.cashCost;
      this.kpuAISC = history.aisc;
      this.kpuIRRStandard = history.irrStandard;
      this.kpuIRRAfterTax = history.irrAfterTax;
      this.kpuNPVAfterTax = history.npvAfterTax;
      this.kpuNPVStandard = history.npvStandard;
      this.kpuStandardFXRate = history.standardFXRate;
      this.kpuStandardGoldPrice = history.standardGoldPrice;
      this.kpuYearlyCashFlows = history.yearlyCashFlows.sort((a, b) => { return a.year - b.year });
    }
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";
.list-scrollable {
  height:500px;/* or any height you want */
  overflow-y:auto;
}
  // TRANSITION
.todo_todo-item {
    transition: all .35s;
}

.list-item-component {
    transition: background-color .2s, transform .2s;
    border-top: 1px solid #dae1e7;
    &:hover {
        // background-color: #eee;
        transform: translateY(-4px);
  //box-shadow: 0px 3px 10px 0px #ccc;
        transition: all 0.2s;
    }
}
</style>

